require('./bootstrap');

require('../../vendor/redbastie/larawire/resources/js/larawire');

